export default __webpack_public_path__ + "static/media/NeueHaasDisplay-Medium.0bd6a473.woff";